// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PtNbMjdQYTBefV5aKYoo {
  display: flex !important;
  align-items: center !important;
  border-radius: 2px !important;
  letter-spacing: 0.8px;
  font-size: 16px !important;
}

.ZNgFYaMYGJfhpuF7dU3Q {
  cursor: pointer;
  padding: 6px;
  border-radius: 6px;
  background: white;
  box-shadow: 0.5px 0.5px 1px 0 rgba(0, 0, 0, 0.1);
}
.ZNgFYaMYGJfhpuF7dU3Q.g51tJvNTtm2RTU3_BvJe {
  cursor: default;
  background: #f2f2f2;
}

.kzVhXxcysXOWUNIER6rj {
  border-radius: 3px 3px 0 0;
}

.p9KN9GAciPkRM3R9Op2r {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/network/components/common/common.module.scss"],"names":[],"mappings":"AACA;EACE,wBAAA;EACA,8BAAA;EACA,6BAAA;EACA,qBAAA;EACA,0BAAA;AAAF;;AAGA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gDAAA;AAAF;AAEE;EACE,eAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,0BAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AADF","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.dropdown_button {\n  display: flex !important;\n  align-items: center !important;\n  border-radius: 2px !important;\n  letter-spacing: 0.8px;\n  font-size: 16px !important;\n}\n\n.navigation_button {\n  cursor: pointer;\n  padding: 6px;\n  border-radius: 6px;\n  background: white;\n  box-shadow: 0.5px 0.5px 1px 0 rgba(0, 0, 0, 0.1);\n\n  &.disabled {\n    cursor: default;\n    background: #f2f2f2;\n  }\n}\n\n.header_border_radius {\n  border-radius: 3px 3px 0 0;\n}\n\n.no_data {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown_button": `PtNbMjdQYTBefV5aKYoo`,
	"navigation_button": `ZNgFYaMYGJfhpuF7dU3Q`,
	"disabled": `g51tJvNTtm2RTU3_BvJe`,
	"header_border_radius": `kzVhXxcysXOWUNIER6rj`,
	"no_data": `p9KN9GAciPkRM3R9Op2r`
};
export default ___CSS_LOADER_EXPORT___;
